import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getCatalog = createAsyncThunk('/catalog/content', async (nopage) => {
    //const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCatalogdownload?page=${nopage}`, {})
    return response.data;
})

export const katalogSlice = createSlice({
    name: 'catalog',
    initialState: {
        isLoading: false,
        catalog : []
    },
    reducers: {


        addNewCatalog: (state, action) => {
            let {newCatalogObj} = action.payload
            state.catalog = [...state.catalog, newCatalogObj]
        },

        deleteCatalog: (state, action) => {
            let {index} = action.payload
            state.catalog.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getCatalog.pending]: state => {
			state.isLoading = true
		},
        [getCatalog.fulfilled]: (state, action) => {
            state.catalog = action.payload.data
			state.isLoading = false
		},
        [getCatalog.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getCatalog.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getCatalog.fulfilled, (state, action) => {
            state.catalog = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getCatalog.rejected, (state) => {
            state.isLoading = false;
          });
      }
})

export const { addNewCatalog, deleteCatalog } = katalogSlice.actions

export default katalogSlice.reducer